import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        var selector = ".contain:not(img, video)";

        if ($(selector).length) {
            var log = typeof debug !== "undefined";
            if (log) console.log("%cfunction_contain.js initialized", "color: green;");

            function contain(_el, _parent) {
                var elementRatio = _el.clientWidth / _el.clientHeight;
                var parentRatio = _parent.clientWidth / _parent.clientHeight;

                console.log(elementRatio, parentRatio);

                if (elementRatio >= parentRatio) {
                    _el.style.width = "100%";
                    _el.style.height = "auto";
                } else {
                    _el.style.width = "auto";
                    _el.style.height = "100%";
                }
            }

            $(selector).each(function () {
                var instance = $(this);
                var parent = $(this).parent();

                parent.addClass("flex center-content");
                contain(instance[0], parent[0]);
            });

            $(window).on("resizeEnd", function () {
                $(selector).each(function () {
                    var instance = $(this);
                    var parent = $(this).parent();

                    contain(instance[0], parent[0]);
                });
            });
        }
    });
})();
